"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLightHexColor = exports.extractPromptStringValue = exports.paginateQuery = exports.asyncRetry = exports.asyncForEach = void 0;
const lodash_1 = require("lodash");
const asyncForEach = async (array = [], cb = async () => { }) => {
    for (let index = 0; index < (array || []).length; index++) {
        await cb(array[index], index, array);
    }
};
exports.asyncForEach = asyncForEach;
const asyncRetry = (func, count = 3) => {
    // eslint-disable-next-line no-undef
    return new Promise(async (resolve, reject) => {
        let lastError;
        for (let i = 1; i <= count; i++) {
            try {
                resolve(await func());
                return;
            }
            catch (error) {
                lastError = error;
                if (i === count) {
                    reject(lastError);
                    return;
                }
            }
        }
    });
};
exports.asyncRetry = asyncRetry;
/*
Helper function to paginate Firestore queries and retrieve all documents
*/
const paginateQuery = async (query, limit = 1000) => {
    const allDocs = [];
    let lastDoc = null;
    while (true) {
        // Apply pagination if there is a last document
        const queryWithPagination = lastDoc
            ? query.limit(limit).startAfter(lastDoc)
            : query.limit(limit);
        const querySnapshot = await queryWithPagination.get();
        // Add retrieved documents to the results
        allDocs.push(...querySnapshot.docs);
        // If no more documents, exit the loop
        if (querySnapshot.docs.length < limit)
            break;
        // Update lastDoc to the last document in this batch
        lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];
    }
    return allDocs;
};
exports.paginateQuery = paginateQuery;
/*
Helper function to extract prompt's string value from field PROMPT value
*/
const extractPromptStringValue = (promptFieldValue) => {
    if (promptFieldValue && (0, lodash_1.isString)(promptFieldValue.value))
        return promptFieldValue.value;
    if ((0, lodash_1.isString)(promptFieldValue))
        return promptFieldValue; // Backwards compatible
    return null;
};
exports.extractPromptStringValue = extractPromptStringValue;
/**
 * Determines if a hex color is light or dark based on its relative luminance
 * Uses WCAG formula for calculating perceived brightness
 * @param hexColor - Hex color string (e.g., '#ffffff' or '#fff')
 * @returns true if the color is light (needs dark text), false if dark (needs light text)
 */
const isLightHexColor = (hexColor) => {
    // Remove # if present
    const hex = hexColor.replace('#', '');
    // Convert 3-digit hex to 6-digit
    const fullHex = hex.length === 3
        ? hex.split('').map(char => char + char).join('')
        : hex;
    // Parse RGB values
    const r = parseInt(fullHex.substring(0, 2), 16);
    const g = parseInt(fullHex.substring(2, 4), 16);
    const b = parseInt(fullHex.substring(4, 6), 16);
    // Calculate relative luminance using WCAG formula
    // https://www.w3.org/TR/WCAG20-TECHS/G17.html
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    // Threshold of 0.5 - colors above are considered light
    return luminance > 0.5;
};
exports.isLightHexColor = isLightHexColor;
